import { Component, Input, OnInit, ViewChild, AfterViewInit, ElementRef, HostListener, OnDestroy } from '@angular/core';
import { ModalOptions, ModalModule, ModalDirective } from 'ng2-bootstrap';

@Component( {
    selector: 'app-date-modal',
    templateUrl: 'dateModal.component.html',
    styleUrls: ['dateModal.component.css']
})

export class DateModalComponent implements OnInit, AfterViewInit, OnDestroy
{
    @Input() buttons: string[];
    @Input() width = 500;
    @Input() height = 300;
    @Input() title: string;
    @Input() editDate: Date = new Date();

    @ViewChild( 'modal' ) modal: ModalDirective;

    public inputText = '';
    public visible = false;
    private visibleAnimate = false;
    private onClose: Function;
    private modalOptions: ModalOptions;

    public show( onClose?: Function ): void
    {
        this.onClose = onClose;
        this.visible = true;
        setTimeout(() => this.visibleAnimate = true );
    }

    public hide( button: string ): void
    {
        this.reset();
        setTimeout(() => this.visible = false, 150 );
        if ( this.onClose )
        {
            this.onClose( button, this.editDate );
        }
    }

    private reset()
    {
        this.visibleAnimate = false;
        this.buttons = ['Ok'];
        this.title = 'CO Visit Date';
    }

    ngAfterViewInit()
    {
    }

    ngOnDestroy()
    {
    }

    ngOnInit()
    {
        this.reset();
        let options = {
            backdrop: true,
            ignoreBackdropClick: true,
            keyboard: false
        };
        // this.modal.config = options;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/DateModal/dateModal.component.ts